import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EntityView } from '@jms/model';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { EntityBoardStore } from '../../state';
import { boardSegmentTilesBridgeStyles, boardSegmentTilesStyleId } from '../board.segment.tiles/board.segment.tiles.theme';

@Component({
  selector: 'board-view-pills',
  templateUrl: './board.view.pills.component.html',
  styleUrls: ['../board.segment.tiles/board.segment.tiles.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[attr.data-size]': '$compact() ? "compact" : "default"',
  },
})
export class BoardViewPillsComponent {

  protected readonly store = inject(EntityBoardStore);

  private readonly document = inject(DOCUMENT);

  /** Smaller pills on an embedded board (Job Items, Tasks). Not a third display type. */
  protected readonly $compact = computed(() => this.store.$contextIsEmbedded());

  public constructor() {

    DesignSystem.Mount(this.document, boardSegmentTilesStyleId, boardSegmentTilesBridgeStyles);
  }

  protected onSelect(view: EntityView): void {

    if (!view || this.store.$viewId() === view._id) return;

    this.store.changeView(view);
  }
}
